module.exports = __webpack_public_path__ + "img/pointer.b3303077.png";